import {
  Directive,
  HostListener
} from '@angular/core';

import { PageEventsHandler } from '../../services';

@Directive({
  selector: '[turnOnFullscreen]'
})

export class TurnOnFullscreen {
  @HostListener('click') onClick() {
    this.pageEventsHandler.enableFullscreen();
  }

  constructor(
    private pageEventsHandler: PageEventsHandler
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/directives/turn-on-fullscreen/turn-on-fullscreen.directive.ts